module.exports = {"charles_street_condo":{"name":"Charles Street Condo","size":3},"north_toronto_colonial":{"name":"North Toronto Colonial","size":6},"hilton_head":{"name":"Hilton Head","size":7},"lawrence":{"name":"Lawrence","size":3},"leaside":{"name":"Leaside","size":6},"markham":{"name":"Markham","size":2},"north_toronto_condo":{"name":"North Toronto Condo","size":4},"north_toronto_lr_fr":{"name":"North Toronto Living Room & Family Room","size":3},"thornhill":{"name":"Thornhill","size":15},"hazleton":{"name":"Hazleton","size":5}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/albums.json
// module id = VWJf
// module chunks = 0